exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".basePage{height:100%;width:100%;margin:0;padding:0;position:relative}.content_box_cla{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;height:100%}.content_box_cla .left-item-cla{position:relative;width:60%;padding:.833333rem;background-color:#fff}.content_box_cla .right-item-cla{position:relative;margin-left:1.25rem;padding:.833333rem;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27277cad","scoped":false,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":12}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layout/content.vue
// module id = f0S5
// module chunks = 19